import App from './App.svelte';
import './utils.css';

const app = new App({
  target: document.body,
  // props: {
  //   name: 'world',
  // },
});

export default app;
